import { withRouter } from 'react-resource-router';
import { PortalReorderingRoute } from 'view/portal-reorder-experience';
import { helpEditTopicsResource } from './resources';

export const portalReorderRoute = (shouldLoadHelpEditTopicsResource = false) => ({
    path: '/settings/portal-reorder',
    exact: true,
    component: withRouter(PortalReorderingRoute),
    name: 'portal-reorder',
    resources: shouldLoadHelpEditTopicsResource ? [helpEditTopicsResource] : [],
});
